<template>
  <div>
    <div id="north">
      <header-info :cur="10"></header-info>
    </div>
    <div id="menu"></div>
    <div id="center">
      <div class="content">
        <div class="action">
          <div class="hidebox">
            <div class="action-left">
              <div v-if="category==1"><i class="iconfont">&#xe603;</i><span>通知公告</span>|</div>
              <div v-if="category==2"><i class="iconfont">&#xe633;</i><span>新闻资讯</span>|</div>
              <div v-if="category==3"><i class="iconfont">&#xe601;</i><span>下载专区</span>|</div>
              <div>
                <span>排序：</span>
                <!-- <span>最新<i class="iconfont">&#xe65a;</i></span> -->
                <select
                  id=""
                  v-model="queryInfo.ordering"
                  @change="getInfo"
                >
                  <option value="-publishDate">最新</option>
                  <option
                    value="-view_count"
                    v-if="category == 1 || category == 2"
                  >浏览量</option>
                  <option
                    value="-download_count"
                    v-if="category == 3"
                  >下载量</option>
                </select>
              </div>
            </div>
            <div class="action-right">
              <span v-if="isShow">共找到{{infoDataCount}}个包含 “<strong>{{queryInfo.title}}</strong>” 的结果</span>
              <div>
                <input
                  type="text"
                  v-model="queryInfo.title"
                >
                <span @click="searchExperimenth">搜索</span>
              </div>
            </div>
          </div>
        </div>
        <ul
          class="rank-list hidebox"
          :class="category=='3'?'download-list':''"
        >
          <router-link
            tag="li"
            v-for="item in infoData"
            :key="item.id"
            :to="'/www/news/detail?id=' + item.id + '&category='+item.category"
          >
            <div
              class="datetime"
              v-if="category!=3"
            >
              <span>{{ item.publishDate.substr(0, 4) }}</span>
              <span>{{ item.publishDate.substr(5, 2) + '/' + item.publishDate.substr(8, 2) }}</span>
            </div>
            <div
              class="info"
              v-if="category!=3"
            >
              <div class="title">
                <span
                  v-if="item.level==3"
                  class="tag"
                >校</span>
                <span>{{item.title}}</span>
              </div>
              <div class="des">{{formatStyle(item.contents)}}</div>
            </div>
            <div
              class="download-info"
              v-if="category==3"
            >
              <div class="title">
                {{item.title}}
              </div>
              <div class="des">
                <span>上传时间：{{ item.publishDate.substr(0,10).replace(/-/g,'/') }}</span>
              </div>
            </div>
            <div class="grade">
              <i
                v-if="category!=3"
                class="iconfont"
              >&#xe602;</i>
              <i
                v-if="category==3"
                class="iconfont"
              >&#xe601;</i>
              <span>{{category==3?item.download_count:item.view_count}}</span>
            </div>
          </router-link>
        </ul>
        <!-- 分页 -->
        <pagination
          class="hidebox"
          :cur='pageInfo.page'
          :all='pageInfo.all'
          :totalData="pageInfo.totalData"
          :callback="pageCallback"
        ></pagination>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import Pagination from '../../../components/Pager'

export default {
  name: 'More',
  components: {
    HeaderInfo,
    FooterInfo,
    Pagination
  },
  data() {
    return {
      category: '1',
      infoData: [],
      infoDataCount: 0,
      infoDataMobile: [],
      infoDataCountMobile: 0,
      queryInfo: {
        title: '',
        ordering: '-publishDate',
        page: 1,
        size: 10,
        status: 1,
        category: this.$route.query.category
      },
      queryInfoMobile: {
        title: '',
        ordering: '-publishDate',
        page: 1,
        size: 10,
        status: 1,
        category: this.$route.query.category
      },
      isShow: false
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.category = to.query.category
        this.queryInfo.category = to.query.category
        this.queryInfoMobile.category = to.query.category
        window.screenWidth = document.body.clientWidth
        if (window.screenWidth < 1000) {
          this.getInfoMobile()
        } else {
          this.searchExperimenth()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.category = this.$route.query.category
    window.screenWidth = document.body.clientWidth
    if (window.screenWidth < 1000) {
      this.getInfoMobile()
    } else {
      this.searchExperimenth()
    }
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.infoDataCount / this.queryInfo.size),
        totalData: this.infoDataCount
      }
    }
  },
  methods: {
    formatStyle(str) {
      str = str.replace(/<\/?[^>]*>/g, '') // 匹配所有html标签
      str = str.replace(/<p[^>]*>/g, '<p class="tag-class">') // 去除标签内所有属性，并设置自定义类名
      str = str.replace(/(\n)/g, '') // 去除换行
      str = str.replace(/\s+style="[^"]*"/g, '') // 去除style样式
      str = str.replace(/&nbsp;/gi, '') // 去除空格
      return str
    },
    formatTime(value, code) {
      var date = new Date(value)
      if (code === 1) {
        return date.getDate()
      } else {
        return date.getFullYear() + '/' + (date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth() + 1)
      }
    },
    getInfo(e) {
      this.queryInfo.ordering = e.target.value
      this.searchExperimenth()
    },
    async searchExperimenth() {
      await this.$http.get('/allowany/info/', {
        params: this.queryInfo
      }).then((data) => {
        this.infoData = data.results
        this.infoDataCount = data.count
        this.isShow = !!this.queryInfo.title.length
      }).catch(() => {
        this.$layer.msg('获取资讯信息失败！')
      })
    },
    async getInfoMobile() {
      await this.$http.get('/allowany/info/', {
        params: this.queryInfoMobile
      }).then((data) => {
        if (this.queryInfoMobile.page === 1) {
          this.infoDataMobile = data.results
        } else {
          this.infoDataMobile = this.infoDataMobile.concat(data.results)
        }
        this.infoDataCountMobile = data.count
        this.isShow = !!this.queryInfo.title.length
      }).catch(() => {
        this.$layer.msg('获取资讯信息失败！')
      })
    },
    pageCallback(data) {
      this.queryInfo.page = data
      this.searchExperimenth()
    },
    loadMore() {
      this.queryInfoMobile.page = this.queryInfoMobile.page + 1
      this.getInfoMobile()
    }
  }
}
</script>

<style lang="less" scoped>
#center {
  background: #E9F8F6;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.action {
  width: 100%;
  height: 104px;
  background: url(../../../assets/images/bg.jpg) no-repeat;
  background-size: 100% auto;
  background-position: center;
  & > div {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .action-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > div {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        &:first-child {
          color: #333;
          i {
            font-size: 24px;
            margin-right: 10px;
          }
          span {
            font-size: 18px;
            font-weight: bold;
            margin-right: 20px;
          }
        }
        &:last-child {
          margin-left: 20px;
          select {
            background: none;
            border: none;
            outline: none;
          }
          span {
            font-size: 14px;
            color: #999;
            &:last-child {
              color: #333;
            }
          }
        }
      }
    }
    .action-right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > span {
        margin-right: 20px;
      }
      & > div {
        input {
          width: 155px;
          height: 30px;
          border: none;
          outline: none;
        }
        span {
          padding: 2px 10px;
          color: #fff;
          background: linear-gradient(to left, #6FD1C8, #00B5A0);
          border-radius: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .action {
    height: 60px;
  }
}
.rank-list {
  width: 1200px;
  margin: 30px auto;
  li {
    height: 135px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    .datetime {
      width: 85px;
      height: 95px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #f6fafd;
      margin-left: 20px;
      border: 1px solid #e5e8ef;
      span {
        font-size: 16px;
        color: #333;
        margin: 2px;
        &:first-child {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .info {
      // width: 60%;
      flex: 1;
      max-width: 800px;
      // margin-left: -240px;
      .title {
        font-size: 18px;
        color: #333;
        font-weight: bold;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .tag {
          width: 20px;
          height: 20px;
          color: #fff;
          font-size: 14px;
          background: #ff2603;
          display: inline-block;
          text-align: center;
          line-height: 20px;
          margin-right: 10px;
        }
      }
      /deep/.des {
        font-size: 14px;
        color: #999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        img {
          display: none;
        }
      }
    }
    .download-info {
      margin-left: 20px;
      .title {
        font-size: 18px;
        color: #333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .des {
        span {
          margin-right: 20px;
          color: #999;
        }
        img {
          display: none;
        }
      }
    }

    .grade {
      width: 160px;
      height: 80%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-left: 1px solid #ebeff7;
      i {
        font-size: 18px;
      }
      span {
        font-size: 16px;
        color: #666666;
        display: inline-block;
        &:last-child {
          color: #dc2f2f;
          font-size: 22px;
          font-weight: bold;
          margin-top: 10px;
        }
      }
    }
  }
}
.download-list {
  li {
    height: 96px;
  }
}

.mobile {
  .list-info {
    padding: 10px 15px;
    li {
      margin-bottom: 20px;
      border-bottom: 1px solid #efefef;
      padding-bottom: 5px;
      & > p {
        &:first-child {
          font-size: 15px;
          color: #333;
          margin-bottom: 10px;
        }
        &:nth-child(2n) {
          font-size: 14px;
          color: #999;
          margin-bottom: 10px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
        &:last-child {
          font-size: 12px;
          color: #ccc;
        }
      }
    }
  }
}
.load-more {
  width: 100px;
  height: 30px;
  border: 1px solid #73D6CA;
  text-align: center;
  line-height: 30px;
  color: #73D6CA;
  margin: 20px auto;
  position: relative;
  z-index: 100;
}
#pagination {
  margin-top: -20px;
  margin-bottom: 40px;
}
</style>
